export default __webpack_public_path__ + "static/media/photoshop.047cad20.png";